export default {
    invoke: (method, payload) => {
        const isIpcAvailable = typeof window !== "undefined" && window.__ELECTRON__ && window.__ELECTRON__.ipcRenderer && typeof window.__ELECTRON__.ipcRenderer.invoke === "function";
        if (isIpcAvailable) {
            return window.__ELECTRON__.ipcRenderer.invoke(method, payload);
        } else {
            throw new Error("Not in electron environment!");
        }
    },
    send: (method, payload) => {
        const isIpcAvailable = typeof window !== "undefined" && window.__ELECTRON__ && window.__ELECTRON__.ipcRenderer && typeof window.__ELECTRON__.ipcRenderer.send === "function";
        if (isIpcAvailable) {
            return window.__ELECTRON__.ipcRenderer.send(method, payload);
        } else {
            throw new Error("Not in electron environment!");
        }
    },
    on: (method, callback) => {
        const isIpcAvailable = typeof window !== "undefined" && window.__ELECTRON__ && window.__ELECTRON__.ipcRenderer && typeof window.__ELECTRON__.ipcRenderer.on === "function";
        if (isIpcAvailable) {
            return window.__ELECTRON__.ipcRenderer.on(method, callback);
        } else {
            throw new Error("Not in electron environment!");
        }
    },
    removeListener: (method, callback) => {
        const isIpcAvailable = typeof window !== "undefined" && window.__ELECTRON__ && window.__ELECTRON__.ipcRenderer && typeof window.__ELECTRON__.ipcRenderer.removeListener === "function";
        if (isIpcAvailable) {
            return window.__ELECTRON__.ipcRenderer.removeListener(method, callback);
        } else {
            throw new Error("Not in electron environment!");
        }
    },
};
